
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"183","height":"140","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"d":"M6 97v37.095h37V140H0V97h6zm177 0v43h-43v-5.905h37V97h6zm-34.417-77.875A11.84 11.84 0 01160 30.542v79.916a11.84 11.84 0 01-11.417 11.417H34.417A11.84 11.84 0 0123 110.458V30.542a11.84 11.84 0 0111.417-11.417zm0 11.417H34.417v79.916h114.166V30.542zM74.375 77.635c9.476 0 28.542 4.795 28.542 14.271v7.136H45.833v-7.136c0-9.476 19.066-14.27 28.542-14.27zm0-35.677a14.27 14.27 0 010 28.542c-7.882 0-14.27-6.39-14.27-14.27 0-7.882 6.388-14.272 14.27-14.272zm51.375 22.834V70.5h-22.833v-5.708h22.833zm11.417-11.417v5.708h-34.25v-5.708h34.25zm0-11.417v5.709h-34.25v-5.709h34.25zM183 0v43h-6V5.905h-37V0h43zM43 0v5.905H6V43H0V0h43z","id":"a"}})]),_c('use',{attrs:{"fill":"#717171","fill-rule":"nonzero","xlink:href":"#a"}})])
          )
        }
      }
    